import * as React from "react";

export const Logo: React.FC = () => {
  return (
    <img
      src="https://cdn.builder.io/api/v1/image/assets/17cfa75daf82417693353b2f7dd2694b/874b4c2fd16fff8169052db51ac211dfcaea4488242a84881413eb6a2c195f79?placeholderIfAbsent=true"
      alt="Company Logo"
      className="object-contain shrink-0 aspect-[3.41] w-[82px]"
    />
  );
};
